import React from 'react';
import { Drawer, List, ListItem, ListItemIcon, ListItemText, Box, Toolbar, Tooltip } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import AssignmentIcon from '@mui/icons-material/Assignment';
import SettingsIcon from '@mui/icons-material/Settings';
import DescriptionIcon from '@mui/icons-material/Description';
import styles from './AdminDashboard.module.css';

const sidebarItems = [
  { text: 'Dashboard', icon: <DashboardIcon />, view: 'dashboard' },
  { text: 'Interviewees', icon: <PeopleIcon />, view: 'interviewees' },
  { text: 'Interview Reports', icon: <AssignmentIcon />, view: 'interviews' },
  { text: 'AI Assistant Instructions', icon: <SettingsIcon />, view: 'aiInstructions' },
  { text: 'Interview Templates', icon: <DescriptionIcon />, view: 'templates' },
  { text: 'Manage AI Instructions', icon: <SettingsIcon />, view: 'manageAiInstructions' }
];

const Sidebar = ({ collapsed, resetView }) => {
  return (
    <Drawer
      variant="permanent"
      className={collapsed ? styles.drawerPaperCollapsed : styles.drawerPaper}
    >
      <Toolbar />
      <Box sx={{ overflow: 'auto' }}>
        <List>
          {sidebarItems.map((item) => (
            <Tooltip key={item.text} title={item.text} placement="right" arrow>
              <ListItem 
                button 
                onClick={() => resetView(item.view)}
                className={styles.sidebarItem}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={collapsed ? '' : item.text} />
              </ListItem>
            </Tooltip>
          ))}
        </List>
      </Box>
    </Drawer>
  );
};

export default Sidebar;
